import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import {
    globalNotificationState,
    GlobalNotification,
} from '@states/globalNotification';
import type { NotificationTypes } from '@molecules/notificationBanner/NotificationBanner';

export type SetNotification = (
    type: NotificationTypes,
    content: string,
    isBlocking?: boolean,
    msBeforeDismiss?: number,
) => void;

// TODO: change this hook to use react-toastify
const useGlobalNotification = (): {
    notification: GlobalNotification;
    clearNotification: () => void;
    setNotification: SetNotification;
} => {
    const [notification, setNotificationAtom] = useRecoilState(
        globalNotificationState,
    );

    const clearNotification = useCallback(
        () =>
            setNotificationAtom({
                type: undefined,
                content: undefined,
                isBlocking: undefined,
                msBeforeDismiss: undefined,
            }),
        [setNotificationAtom],
    );

    const setNotification = useCallback(
        (
            type: NotificationTypes,
            content: string,
            isBlocking?: boolean,
            msBeforeDismiss?: number,
        ) =>
            setNotificationAtom({
                type,
                content,
                isBlocking: isBlocking || true,
                msBeforeDismiss: msBeforeDismiss || 5000,
            }),
        [setNotificationAtom],
    );

    return {
        notification,
        clearNotification,
        setNotification,
    };
};

export default useGlobalNotification;
